module.exports = __webpack_public_path__ + "static/media/play_darkbleu.616d81b0.svg";